<template>
  <div
    class="PropertyProjectInformationInquiryList vheight container-boot PublicInformationView"
  >
    <div
      class="container-boot"
      :style="{ height: 'calc(100% - 45px - ' + headerHeight + 'px )' }"
    >
      <div class="row">
        <div class="col-md-2 col-xs-12 default-col">
          <div class="search">
            <div class="search-panel">
              <div class="search-tips">物业项目名称</div>
              <el-input
                placeholder="物业项目名称"
                v-model="areaName"
                clearable
              ></el-input>
            </div>
            <div class="search-panel">
              <div class="search-tips">物业企业名称</div>
              <el-input
                placeholder="物业企业名称"
                v-model="orgName"
                clearable
              ></el-input>
            </div>
            <div class="search-panel">
              <div class="search-tips">项目所在区名</div>
              <el-input
                placeholder="项目所在区名"
                v-model="cantonName"
                clearable
              ></el-input>
            </div>
            <div class="search-button">
              <el-button
                type
                icon="el-icon-search"
                size="small"
                @click="getData('clear')"
                >搜索</el-button
              >
            </div>
          </div>
        </div>
        <!-- 表格内容 -->
        <div class="col-md-10 col-xs-12 default-col table-grid">
          <div class="container-header">
            <!-- <span>数据下载：</span>
            <ps-export>导出EXCEL</ps-export>-->
          </div>
          <div class="grid">
            <el-table
              :data="dataFeed"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              stripe
              border
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
            >
              <!-- 加载的时候不要显示暂无数据 -->
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                type="index"
                label="序号"
                width="50"
              ></el-table-column>
              <el-table-column
                label="物业项目名称"
                prop="EaAreaName"
                show-overflow-tooltip
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <span
                    class="row-name"
                    @click="
                      handleDetail(
                        scope.row.PropertyCode,
                        scope.row.EaAreaCode,
                        scope.row.OwnerTeamCode
                      )
                    "
                    style="color: #2a7bbe"
                    >{{ scope.row.EaAreaName || '--' }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                :formatter="formatter"
                label="物业企业名称"
                prop="PropertyName"
                show-overflow-tooltip
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.PropertyName || '--'
                }}</template>
                <!-- <template slot-scope="scope">
                    <span>{{ getproPertyMgeInfo(scope.row.PropertyCode).then(value => vale) }}</span>
                </template>-->
              </el-table-column>
              <!-- <el-table-column
                  label="项目负责人"
                  width="150"
                  prop="PropertyManager"
                  show-overflow-tooltip
                  header-align="center"
                  align="center"
              ></el-table-column>-->
              <el-table-column
                :formatter="formatter"
                label="项目所属区"
                max-width="150"
                prop="PropertyCantonName"
                show-overflow-tooltip
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.PropertyCantonName || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                label="项目类型"
                max-width="150"
                show-overflow-tooltip
                header-align="center"
                projecType
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.EBuildingTypeName || '--' }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div
              class="footer"
              style="display: flex; flex-direction: row-reverse"
            >
              <div class="page">
                <ps-page :page="page" @getData="getData()"></ps-page>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ArticleControllerSvr } from '@/service/ArticleControllerSvr.js';
import { PropertyProjectControllerSvr } from '@/service/PropertyProjectControllerSvr/PropertyProjectControllerSvr.js';
import { PropertyMgeInfoControllerSvr } from '@/service/InformationMaintenanceReport/InformationMaintenanceReport.js';
import { EnumController } from '@/service/EnumController/EnumController.js';
import { ArticleQueryPara } from '@/models/queryparams/ArticleQueryPara.js';
import { headerredraw } from '@/mixin/headerredraw';
import { mapState } from 'vuex';
import { Page } from '@/models/page';
export default {
  name: 'PropertyProjectInformationInquiryList',
  metaInfo: {
    title: '业主大会和业委会查询',
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no',
      },
      { name: 'SiteName', content: '深圳市住房和建设局网站' },
      { name: 'SiteDomain', content: 'zjj.sz.gov.cn' },
      { name: 'SiteIDCode', content: '4403000005' },
      { name: 'ColumnName', content: '物业管理政策专题' },
      {
        name: 'ColumnDescription',
        content: '该栏目公布物业管理政策专栏的信息。',
      },
      { name: 'ColumnKeywords', content: '物业管理政策专栏' },
      { name: 'ColumnType', content: '其他' },
    ],
  },
  components: {},
  props: {},
  mixins: [headerredraw],
  data() {
    return {
      projecType: {},
      page: new Page(),
      ArticleQueryPara: new ArticleQueryPara(),
      isHide: false, //隐藏部分搜索框
      dataFeed: [],
      keyWords: '',
      dialogVisible: false,
      orgName: '',
      areaName: '',
      cantonName: '',
      OrgNameArray: [],
      // projecType: new ProjecType()
      loading: false,
    };
  },
  computed: { ...mapState(['token']) },
  created() {
    this.EnumController = new EnumController();
    this.ArticleControllerSvr = new ArticleControllerSvr();
    this.PropertyProjectControllerSvr = new PropertyProjectControllerSvr();
    this.PropertyMgeInfoControllerSvr = new PropertyMgeInfoControllerSvr();
  },
  mounted() {
    this.getData();
  },
  methods: {
    //空数据处理
    formatter(row, column, cellValue, index) {
      return cellValue === null || cellValue === '' ? '--' : cellValue;
    },
    getData(state) {
      this.loading = true;
      if (state == 'clear') {
        this.page.currentPage = 1;
      }
      this.PropertyProjectControllerSvr.GetPrejectDetailList(
        this.orgName,
        this.areaName,
        this.cantonName,
        (this.page.currentPage - 1) * this.page.currtNum,
        this.page.currtNum
      )
        .then(
          (res) => {
            this.loading = false;
            this.page.getCurrtNum = res.TotalCount;
            this.dataFeed = res._Items;
          },
          (err) => {
            this.loading = false;
            this.$message({
              message: err,
              type: 'error',
            });
          }
        )
        .catch(() => {
          this.loading = false;
        });
    },
    handleDetail(OrgCode, EaAreaCode, OwnerTeamCode) {
      this.$router.push({
        path: '/PropertyProjectInformationDetailList',
        query: {
          orgCode: OrgCode,
          eaAreaCode: EaAreaCode,
          ownerTeamCode: OwnerTeamCode,
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.PublicInformationView {
  height: 100%;
  width: 100%;

  .container-boot {
    height: 100%;
    width: 100%;

    .table-grid {
      height: 100%;

      .grid {
        height: calc(100% - 60px);
      }
    }
  }

  padding: 0 10px;

  .container-header {
    text-align: right;
    margin-top: 6px;
    margin-bottom: 6px;
  }

  .search {
    text-align: right;

    .search-panel {
      display: inline;

      .search-tips {
        height: 40px;
        line-height: 40px;
        font-weight: bold;
        text-align: left;
        padding-left: 20%;
      }

      .el-input {
        .el-input__inner {
          width: 80%;
        }
      }

      .el-select {
        width: 100%;
      }
    }

    .search-button {
      margin-top: 20px;
    }
  }

  .row {
    height: 100%;

    .default-col {
      .el-table {
        // height: calc(100% - 100px);
        height: calc(100% - 60px) !important;
        overflow: auto;

        .row-name {
          &:hover {
            text-decoration: underline;
            cursor: pointer;
          }
        }

        .has-gutter {
          color: black;
        }
      }

      // .table-grid {
      //   height: inherit
      // }
    }
  }
}
</style>
<style lang="scss" scoped>
.PropertyProjectInformationInquiryList {
  .header-seacher {
    .header-firstLine {
      .datetime {
        width: 480px;
      }

      .searchButton {
        width: 240px;
      }
    }
  }

  .function {
    min-width: 400px;
  }

  .container-boot {
    .grid {
      height: 100%;
    }
  }

  .el-dialog {
    .el-dialog__header {
      .dialog-title {
        font-size: 18px;

        .DialogTitle {
          font-size: 18px;
          color: #409eff;
        }
      }
    }

    .el-dialog__body {
      height: 630px;
      overflow: auto;
      padding: 0 !important;
    }
  }
}
</style>
